export default "__VITE_ASSET__Dsmzac3u__"